var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Checkbox, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useMemo } from 'react';
import { setFilePath, setIsOpenDialog } from '../../../../application/features/global-search/globalSearchSlice';
import { graphApi } from '../../../../application/features/microsoft-graph/microsoft-graph-api';
import { useAppDispatch } from '../../../../application/store/useStore';
import DocumentStatusTag from '../../../components/DocumentStatusTag';
import PdfIcon from '../../../icons/components/pdf-icon';
var OthersCard = function (_a) {
    var id = _a.id, title = _a.title, disabled = _a.disabled, uploadingStatus = _a.uploadingStatus, processingStatus = _a.processingStatus, addedToKnowledgeBase = _a.addedToKnowledgeBase, pdfFilePath = _a.pdfFilePath, isSelected = _a.isSelected, onToggleSelect = _a.onToggleSelect;
    var theme = useTheme();
    var isXs = useMediaQuery(theme.breakpoints.down('sm'));
    var isMd = useMediaQuery(theme.breakpoints.down('lg'));
    var dispatch = useAppDispatch();
    var zoomLevel = useMemo(function () { return (isMd ? 0.2 : 0.8); }, [isMd]);
    var onViewDocument = function () { return __awaiter(void 0, void 0, void 0, function () {
        var previewUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, graphApi.getPreviewUrl(pdfFilePath, '1', zoomLevel)];
                case 1:
                    previewUrl = _a.sent();
                    dispatch(setFilePath(previewUrl));
                    dispatch(setIsOpenDialog(true));
                    return [2 /*return*/];
            }
        });
    }); };
    var handleCheckboxClick = function (e) {
        e.stopPropagation();
        onToggleSelect === null || onToggleSelect === void 0 ? void 0 : onToggleSelect(id);
    };
    return (_jsx(Box, { sx: {
            padding: isXs ? '10px 12px' : '16px 8px 16px 20px',
            transition: 'border-color 0.3s ease',
            border: "2px solid ".concat(isSelected ? theme.palette.primary.main : 'rgba(145, 158, 171, 0.2)'),
            gap: '4px',
            borderRadius: '16px',
            opacity: disabled ? 0.6 : 1,
            cursor: disabled ? 'default' : 'pointer'
        }, children: _jsxs(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center', children: [_jsxs(Box, { onClick: disabled ? undefined : onViewDocument, display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'center', sx: { flex: 1, minWidth: 0 }, children: [_jsx(PdfIcon, { width: isXs ? 20 : 40, height: isXs ? 20 : 40 }), _jsxs(Box, { sx: { flex: 1, minWidth: 0 }, children: [_jsx(Typography, { noWrap: true, fontWeight: 500, fontSize: 15, color: 'text.primary', children: title }), _jsx(DocumentStatusTag, { uploadingStatus: uploadingStatus, processingStatus: processingStatus, addedToKnowledgeBase: addedToKnowledgeBase })] })] }), _jsx(Checkbox, { size: 'small', color: 'primary', disabled: disabled, checked: isSelected, onClick: handleCheckboxClick })] }) }));
};
export default OthersCard;
